import LoadingProgressbar from './loading-progressbar-component';

import './loading-progressbar.scss';

const MODULE_NAME = 'loading-progressbar';
const module = angular.module(MODULE_NAME, [])
    .directive(LoadingProgressbar.DIRECTIVE_NAME, LoadingProgressbar);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/directives/loading-progressbar/loading-progressbar-module.js